const ASSET_TYPE_BY_FORMAT = {
    svg: "ImageVector",
    png: "ImageBitmap",
    jpg: "ImageBitmap",
    jpeg: "ImageBitmap",
    bmp: "ImageBitmap",
    gif: "ImageBitmap",
    wav: "Sound",
    mp3: "Sound",
};

const toBytes = (entry) => {
    const raw = entry.assetData ?? entry.asset?.data;
    if (!raw) return null;

    if (raw instanceof Uint8Array) return raw;
    if (Array.isArray(raw)) return Uint8Array.from(raw);
    if (typeof raw === "object") return Uint8Array.from(Object.values(raw));
    return null;
};

const formatOf = (entry) =>
    (entry.dataFormat || entry.asset?.dataFormat || "").toLowerCase();

const resolveAssetType = (storage, format, entry) => {
    const name =
        ASSET_TYPE_BY_FORMAT[format] || entry.asset?.assetType?.name || null;

    return name ? storage.AssetType[name] || null : null;
};

export const precacheProjectAssets = (vm, projectOrJson) => {
    const storage = vm?.runtime?.storage;
    if (!storage?.cache) return;

    let project = projectOrJson;
    if (typeof project === "string") {
        try {
            project = JSON.parse(project);
        } catch (e) {
            return;
        }
    }
    if (!project?.targets) return;

    const cacheOne = (entry) => {
        if (!entry?.assetId) return;

        const format = formatOf(entry);
        const assetType = resolveAssetType(storage, format, entry);
        const bytes = toBytes(entry);
        if (!format || !assetType || !bytes?.length) return;

        try {
            storage.cache(assetType, format, bytes, entry.assetId);
        } catch (e) {
            console.error("Could not cache project asset", entry.assetId, e);
        }
    };

    for (const target of project.targets) {
        (target?.costumes || []).forEach(cacheOne);
        (target?.sounds || []).forEach(cacheOne);
    }
};
